// Module
var code = `<breadcrumbs></breadcrumbs>
<gl-header>
  <div class="info__column">
      <span class="info__field" ng-repeat="entry in \$ctrl.header">
        <span class="info__field-label">{{entry.label}}:</span>
        <span class="info__field-value">{{entry.text}}</span>
      </span>
  </div>
  <div class="info__column">
    <button class="btn"
            type="button"
            ng-class="\$ctrl.editingEnabled ? 'btn-warning' : 'btn-info'"
            ng-if="\$ctrl.hasEditAccess || \$ctrl.hasCreateAccess"
            ng-click="\$ctrl.toggleEditing();">{{\$ctrl.editingEnabled ? "Finish Editing" : "Edit Gl Structure"}}
    </button>
    <refresh-button on-refresh="\$ctrl.refetchAccounts()"></refresh-button>
  </div>
</gl-header>
<section class="box">
<sub-header header="'GL account'"></sub-header>
<table class="table table--last-column-to-right">
  <thead>
    <tr>
      <th class="number no-column">No</th>
      <th class="name">Name</th>
      <th class="code">Code</th>
      <th class="balance">Balance</th>
      <th ng-if="\$ctrl.editingEnabled">Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="a in \$ctrl.accounts" class="account-row"
        ng-class="{collapsed: a.collapsed, hide: !a.visible}"  ng-click="\$ctrl.toggleCollapsed(a)">
      <td>{{\$index + 1}}</td>
      <td class="gl-account-details__account-name" ng-class="{toggle: a.hasSubAccounts}">
        <span class="buffer"
              ng-style="{'padding-left': 'calc(1rem * ({{a.accountDepth}} - 1))'}">
        </span>
        <span class="icon-container">
          <i class="icon-collapse"></i>
          <i class="icon-expand"></i>
        </span>

        <span class="label label-inverse group-label" title="{{a.accountGroup}}">{{a.accountGroupShort}}</span>
        {{a.name}}
      </td>
      <td title="{{a.fullCode}}">
        <i class="icon icon-info-sign"></i>
        {{a.code}}
      </td>
      <td ng-class="{'green': a.balance > 0, 'red': a.balance < 0}">{{a.balance | nxCurrency:'negativeBrackets'}}</td>
      <td ng-if="\$ctrl.editingEnabled" class="table__actions">
        <button class="btn btn-primary"
                type="button"
                ng-if="\$ctrl.hasEditAccess"
                ng-click="\$ctrl.edit(a, \$event);">Edit</button>
        <button class="btn btn-info"
                type="button"
                ng-if="\$ctrl.isNotLeafOrAtLeastHasNoTransactions(a) && \$ctrl.hasCreateAccess"
                ng-click="\$ctrl.createLeafAccount(a, \$event);">Add leaf</button>
      </td>
    </tr>
  </tbody>
</table>
</section>

<modal on-api-ready="\$ctrl.onModalApiReady">
  <modal-header><h2>{{\$ctrl.createAccountMode ? "Create Ledger Account" : "Edit Ledger Account"}}</h2></modal-header>
  <modal-body>
    <form name="form">
      <table class="misc-transaction__table table">
        <tbody>
        <tr ng-if="\$ctrl.createAccountMode">
          <td>Parent Full Code</td>
          <td>
            <input
              required
              type="text"
              ng-value="\$ctrl.input.parentFullCode"
              disabled/>
          </td>
        </tr>
        <tr>
          <td>Account Code</td>
          <td>
            <input
              type="text"
              required
              ng-disabled="\$ctrl.editAccountMode"
              ng-model="\$ctrl.input.code"/>
          </td>
        </tr>
        <tr>
          <td>Account Name</td>
          <td>
            <input
              type="text"
              required
              maxlength="256"
              ng-model="\$ctrl.input.name"/>
          </td>
        </tr>
        <tr ng-if="\$ctrl.createAccountMode">
          <td>Display Order After</td>
          <td>
            <select
              ng-model="\$ctrl.input.displayAfter"
              ng-options="o for o in \$ctrl.displayAfterOptions"
              required>
            </select>
          </td>
        </tr>
        <tr>
          <td>Reversed entry type</td>
          <td>
            <select
              ng-model="\$ctrl.input.isReversed"
              boolean-options
              required>
            </select>
          </td>
        </tr>
        </tbody>
      </table>
    </form>
  </modal-body>
</modal>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/general-ledger/accounts/gl-account-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;